import { render, staticRenderFns } from "./TodoAddNew.vue?vue&type=template&id=5ec06d7a&"
import script from "./TodoAddNew.vue?vue&type=script&lang=js&"
export * from "./TodoAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports